// Import the functions you need from the SDKs you need

import firebase from 'firebase/compat/app';
import  'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAOYESj9YZfq0W4bBxuHuIDi-t8OcleV8I",
  authDomain: "northway-clound.firebaseapp.com",
  projectId: "northway-clound",
  storageBucket: "northway-clound.appspot.com",
  messagingSenderId: "356189688289",
  appId: "1:356189688289:web:efb8a7c8e73eb9c486c2a0",
  measurementId: "G-ZSLL5YTJ7K"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const firebase_Db = firebase.firestore();
const firebase_Auth = firebase.auth();
const FStorage = firebase.storage();

export { firebase_Db, firebase_Auth, FStorage, };